import { Receipt, ListBullets, Wallet, Coins, Scissors, UsersThree, Stack, Money, ChartLineUp, Package, Ticket, ChalkboardTeacher, Student, GraduationCap } from 'phosphor-react';

// Single source of truth for navigation. Each item declares the capability that unlocks it; the
// shell filters by the server-issued capability map (never by role strings). `end` marks the
// per-role landing route.
export const NAV_ITEMS = [
    // Employee
    { to: '/tao-hoa-don',       label: 'Tạo hoá đơn',      icon: Receipt,     cap: 'canCreateTransaction', group: 'Vận hành' },
    { to: '/ban-goi',           label: 'Bán gói',          icon: Ticket,      cap: 'canSellPackage',       group: 'Vận hành' },
    { to: '/giao-dich-cua-toi', label: 'Giao dịch của tôi', icon: ListBullets, cap: 'canViewOwnStats',       group: 'Vận hành' },
    { to: '/luong-cua-toi',     label: 'Lương của tôi',     icon: Wallet,      cap: 'canViewOwnStats',       group: 'Vận hành' },
    // Manager
    { to: '/bang-luong',  label: 'Bảng lương',  icon: Coins,       cap: 'canViewAllPayouts',      group: 'Vận hành' },
    { to: '/doanh-thu',   label: 'Doanh thu',   icon: ChartLineUp, cap: 'canViewAllPayouts',      group: 'Vận hành' },
    { to: '/tien-mat',    label: 'Tiền mặt',    icon: Money,       cap: 'canConfirmCash',         group: 'Vận hành' },
    { to: '/giao-dich',   label: 'Giao dịch',   icon: Stack,       cap: 'canViewAllTransactions', group: 'Vận hành' },
    { to: '/dich-vu',     label: 'Dịch vụ',     icon: Scissors,    cap: 'canManageServices',      group: 'Khác' },
    { to: '/goi-dich-vu', label: 'Gói dịch vụ', icon: Package,     cap: 'canManagePackages',      group: 'Khác' },
    { to: '/nhan-vien',   label: 'Nhân viên',   icon: UsersThree,  cap: 'canManageEmployees',     group: 'Khác' },
    // Nail class management (manager)
    { to: '/lop-hoc',     label: 'Lớp học',     icon: ChalkboardTeacher, cap: 'canManageClasses', group: 'Lớp nail' },
    { to: '/hoc-vien',    label: 'Học viên',    icon: Student,           cap: 'canManageClasses', group: 'Lớp nail' },
    // Nail class student (student's own dashboard)
    { to: '/lop-cua-toi', label: 'Lớp của tôi', icon: GraduationCap,     cap: 'canViewOwnStudy',  group: 'Vận hành' },
];

export function visibleNavItems(caps) {
    return NAV_ITEMS.filter(item => caps[item.cap]);
}

// Per-role landing path: managers start at the payroll board, employees at invoice entry,
// nail-course students (who have no other salon caps) start at their own class dashboard.
export function defaultPath(caps) {
    if (caps.canViewOwnStudy) return '/lop-cua-toi';
    if (caps.canViewAllPayouts) return '/bang-luong';
    return '/tao-hoa-don';
}
